import type { CycleSchedule } from '@/types/cycle-evaluation/CycleSchedule';

import { api } from '@/api/api';

export default {
    async getCycleSchedule(cycleEvaluationId: string): Promise<CycleSchedule> {
        const response = await api.get(`/cycleschedule/${cycleEvaluationId}`);
        return response.data;
    },

    async updateCycleSchedule(schedule: CycleSchedule): Promise<CycleSchedule> {
        const response = await api.put(`/cycleschedule/${schedule.id}`, schedule);
        return response.data;
    },
};
